<style scoped lang="less">
.layout{display: flex;flex-direction:column;width: 100%;height: 100%;}
.layername{display:flex;width:100%;height: 44px;background-color: #2080ff;border-radius: 6px 6px 0px 0px;align-items: center;
  span{padding-left: 16px;color: #fff;font-size: 14px;}
}
.search{padding-top: 15px;}
.top{height: 100%;padding:9px;overflow: auto;
  .head{width: 100%;height: 30px;background: rgba(21,109,187, .5);margin:0; color: #fff;line-height: 30px;}
}
.country-layer{display: flex;flex-wrap: wrap;justify-content: space-around;width: 94%;padding:3%;}
.layer-box{width: 46%;height: 144px;border: solid 1px rgba(134, 208, 255, 0.2);border-radius: 6px;margin-bottom: 10px;cursor: pointer;
  img{width: 96px;height: 72px;padding-top: 12px;}
  .box-name{width: 78%;padding-left: 11%;font-size: 14px;color: #ffffff;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2; }
}
// .layer-box:hover{background-color: #2080ff;border: solid 1px #7ae9ff;}
.layer-box.check{background-color: #2080ff;border: solid 1px #7ae9ff;}
.bottom{height: 40%;padding:15px;
  .head{width: 100%;height: 30px;background: rgba(21,109,187, .5);margin:0; color: #fff;line-height: 30px;}
}
/deep/.el-tree{background: none; color: #23fffc;}
/deep/.el-checkbox__inner{background: none;border-color:#23fffc !important; background: none !important;}
  /deep/.el-tree-node__content:hover{background-color: #54ffef40;}
/deep/.el-tree-node:focus > .el-tree-node__content {
  background-color: #54ffef40 !important;
}
.package{position: fixed;right: 2%;top: 100px;width: 320px; height: 600px;overflow: auto;}
.icon{margin:0 20px;}
.opacty1{opacity: 1;}
.opacty2{opacity: .5;}
/deep/.el-input{width: 88%;}
/deep/.el-input__inner{height: 32px;line-height: 32px;background-color: transparent;border-radius: 4px;border: solid 1px #6491e0;color: #fff;}
/deep/.el-input__icon{margin-top: -3px;color: #fff;}
/deep/.el-button{background-color: rgba(21,109,187, .5);}
/deep/.el-checkbox__label{background: none; color: #23fffc;font-size: 16px;}
/deep/.el-checkbox__input.is-checked+.el-checkbox__label {color: #23fffc;}

.el-tree /deep/ .el-icon-caret-right:before {
  background: url("../../../../../static/images//tools/展开.svg") no-repeat 0 0;
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-left: 3px;
  background-size: 8px 12px;
}
// 已经展开且有子节点
.el-tree /deep/.el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  background: url("../../../../../static/images//tools/收起.svg") no-repeat 0 0;
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  background-size: 8px 12px;
}
// 没有子节点
.el-tree /deep/.el-tree-node__expand-icon.is-leaf::before {
  background: none;
}
</style>

<template>
  <div class="layout">
    <div class="layername">
      <span>图层（{{ this.layerListname }}）</span>
    </div>
    <div class="search" v-if="ifshow === true">
        <el-input v-model="filterText" placeholder="搜索"></el-input>
        <el-icon class="buticon"><Search /></el-icon>
      </div>
    <div class="top" v-if="ifshow === true">
      <el-tree
        :data="data"
        :show-checkbox="false"
        node-key="id"
        ref="tree"
        @check-change="onChange"
        :default-checked-keys="nodeId"
        :props="defaultProps"
        :filter-node-method="filterNode"
        @node-contextmenu="openMenu">
        <template  slot-scope="{ node, data }">
          <span class="custom-tree-node" v-if="data.children.length >0 ">{{ node.label }}</span>
          <span class="custom-tree-node" :class="(data.url || data.glid === 0)?opacty1:opacty2" v-else>
            <el-checkbox v-model="node.checked">{{ node.label }}</el-checkbox>
          </span>
        </template>
        <!-- <span class="custom-tree-node" slot-scope="{node, data}" :class="(data.url || data.glid === 0)?opacty1:opacty2">
          <span>{{node.label}}</span>
        </span> -->
      </el-tree>
    </div>
    <div class="top" v-if="ifshow === false">
      <div class="country-layer" >
        <div class="layer-box" :class="{check: item.isCheck}" v-for="item in countryLayer" :key="item" @click="onclickCLayer(item)">
          <img :src="item.imgUrl" alt="">
          <div class="box-name">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <RightMenu ref="contextmenu" :styleobj="styleobj" :visible="visible" :layername="layername" @setTransParents="setTransParents"></RightMenu>
  </div>
</template>

<script>
import RightMenu from './RightMenu'
export default {
  components: {RightMenu},
  props: ['attquery'],
  data()
  {
    return {
      ifshow: true,
      filterText: '',
      layerListname: '总览',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'namec',
        disabled: function(data, node)
        {
          if (data.children && data.children.length > 0)

            return true
    
          else
            return false
        }
      },
      lyrCache: {},
      flag: true,
      layername: '',
      visible: false,
      styleobj: {
        top: 0,
        left: 0
      },
      nodeId: [946],
      opacty1: 'opacty1',
      opacty2: 'opacty2',
      centerPoint:
      [
        {country: '菲律宾', center: [123.67, 12.52]},
        {country: '印度尼西亚', center: [127.23, -0.035]},
        {country: '马来西亚', center: [114.23, 3.51]},
        {country: '柬埔寨', center: [105.14, 13.22]},
        {country: '老挝', center: [105.08, 17.47]},
        {country: '缅甸', center: [96.07, 22.83]},
        {country: '泰国', center: [100.72, 17.25]},
        {country: '越南', center: [107.10, 17.29]}
      ],
      // 默认底图
      countryLayer: [],
      countryName: ''
    }
  },
  watch: {
    filterText(val)
    {
      this.$refs.tree.filter(val)
    },
    layerListname(newvalue, oldvalue)
    {
      if (newvalue !== '总览')
        this.ifshow = false
      else
        this.ifshow = true
    },
    visible(value)
    {
      if (value)
        document.body.addEventListener('click', this.closeMenu)
      else
        document.body.removeEventListener('click', this.closeMenu)
    }
  },
  mounted()
  {
    this.$nextTick(() =>
    {
      this.getWMS()
    })
  },
  methods:
  {
    filterNode(value, data)
    {
      if (!value) return true
      return data.namec.indexOf(value) !== -1
    },
    //取wms图层服务
    getWMS()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: 'visible=1', vals: this.Title}
      window.post.getPost(paras).then((ret) =>
      {
        let layerNds = ret.map(item => cx.base.extend({}, item, {children: []}))
        this.data = this.getNodes(layerNds)
        console.log(this.data)
      })
    },
    /**
     * 构造树节点
     * @method
     * @param     {Array<Object>}   nodes   节点数组
     * @returns   {Array<Object>}           构造好的树节点集合
     */
    getNodes(nodes)
    {
      let flterNodes = nodes.filter(node => node.glid === 0)
      for (let i = 0, il = flterNodes.length; i < il; ++i)
        this.makeChildrenData(flterNodes[i].children, flterNodes[i].id, nodes)
      return nodes.filter(node => node.glid === 0)
    },
    /**
     * 构造children数据
     * @method
     * @param   {Array<Object>}   children    父节点的children对象
     * @param   {Number}          glid        父节点的id
     * @param   {Array<Object>}   data        所有节点的源数据集合
     */
    makeChildrenData(children, glid, data)
    {
      let flterData = data.filter(item => item.glid === glid)
      for (let i = 0, il = flterData.length; i < il; ++i)
      {
        //判断该节点是否有图层
        if (!flterData[i].filter)
          flterData[i].icon = 'iconfont icon-bukeshi'
        children.push(flterData[i])
        if (data.some(node => node.glid === flterData[i].id))
          this.makeChildrenData(flterData[i].children, flterData[i].id, data)
      }
    },
    //当前节点选中状态发生变化时触发
    onChange(node, checked, checkild)
    {
      this.nodeId = []
      if (node.children.length > 0)
      {
        node.children.forEach(node =>
        {
          this.$emit('changeLayer', {node, checked, checkild})
        })
      }
      else
        this.$emit('changeLayer', {node, checked, checkild})

      //当前选中状态下
      if (checked && node.children.length === 0)
      {
        let point = this.centerPoint.find(e => e.country === node.namec)
        if (point)
          this.location(point.center)
      }
    },
    // 显示右键菜单
    openMenu(e, data, node)
    {
      this.visible = true
      this.layername = node.data.namec
      this.styleobj.top = e.clientY
      this.styleobj.left = e.clientX
    },
    // 关闭右键菜单
    closeMenu()
    {
      this.visible = false
    },
    //定位
    location(center)
    {
      window.map.getView().animate({ // 只设置需要的属性即可
        center: center, // 中心点
        zoom: 6, // 缩放级别
        duration: 1000 // 缩放持续时间，默认不需要设置
      })
    },
    onclickCLayer(val)
    {
      this.countryLayer.forEach(item =>
      {
        if (item.title === val.title)
          item.isCheck = !item.isCheck
      })
      let checkNode = {node: {url: val.url, layer: val.layer, filter: val.filter, glid: val.glid, namec: this.countryName + '-' + val.title, legendurl: val.legendurl, maptype: val.maptype}, checked: val.isCheck, checkild: val.isCheck}
      this.$emit('changeLayer', checkNode)
    },
    getCountryLayer(val)
    {
      this.countryLayer = []
      this.countryName = val.name
      let paras = {cmd: 'query', _major: 99, _minor: 31, _exp: `country = ${val.value}`}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length > 0)
        {
          ret.forEach(item =>
          {
            this.countryLayer.push({ title: item.namec, isCheck: false, imgUrl: item.thumb ? item.thumb : 'static/images/country_layer.png', url: item.url, layer: item.layer, filter: item.filter, glid: item.glid, legendurl: item.legendurl, maptype: item.maptype })
          })
        }
      })
    },
    setTransParents(evt)
    {
      this.$emit('SetLayerTrans', evt)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/LayerManager.vue